import React from "react";

const Loading = () => {
  return (
    <>
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </>
  );
};

export default Loading;
